import { render } from "./wfm-nsp.vue?vue&type=template&id=6b50d8a0&scoped=true"
import script from "./wfm-nsp.vue?vue&type=script&lang=js"
export * from "./wfm-nsp.vue?vue&type=script&lang=js"

import "./wfm-nsp.vue?vue&type=style&index=0&id=6b50d8a0&scoped=true&lang=css"
import "./wfm-nsp.vue?vue&type=style&index=1&id=6b50d8a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b50d8a0"]])

export default __exports__